export default {
  DAYLOCKDOWNHUB_LIST (state, value) {
    state.list = (value && Array.isArray(value)) ? [...(value.sort((a, b) => a.name.localeCompare(b.name)))] : []
  },
  DAYLOCKDOWNHUB_LIST_ADD (state, value) {
    if (state.list.findIndex((i) => i.id === value.id) === -1) {
      state.list.push({
        id: value.id,
        name: value.name,
        organizations: value.organizations.length,
        users: value.users.length
      })
    }
  },
  DAYLOCKDOWNHUB_LIST_ITEM_REMOVE (state, value) {
    const id = typeof value === 'string' ? value : typeof value === 'object' && value.id ? value.id : ''
    const index = state.list.findIndex((i) => i.id === id)
    if (index !== -1) {
      state.list.splice(index, 1)
    }
  },
  DAYLOCKDOWNHUB_LIST_UPDATE (state, value) {
    const index = state.list.findIndex((i) => i.id === value.id)
    if (index !== -1) {
      state.list.splice(index, 1, Object.assign(state.list[index], value))
    } else {
      state.list.push(value)
    }
  },
  DAYLOCKDOWNHUB_CURRENT (state, value) {
    const props = [
      'acm',
      'boschPanel',
      'dhcp',
      'gateway',
      'info',
      'informaCastFusion',
      'ipAddress',
      'lockdownLogs',
      'messageTemplates',
      'name',
      'restoreLogs',
      'server',
      'subnetMask',
      'system'
    ]
    if (value) {
      for (const prop of props) {
        if (value[prop] !== state.current[prop]) {
          state.current[prop] = value[prop]
        }
      }
      for (const prop of ['id', 'active', 'reenableTime', 'building']) {
        if (value[prop] !== state.current[prop]) {
          state.current[prop] = value[prop]
          state.update[prop] = value[prop]
        }
      }
      console.log(value)
      state.current.lockdownFromAccessCtrlIntrusionOk = value['ifcmsgchanged:lockdownfromaccessctrlintrusion'] || null
      state.current.lockdownToAccessCtrlIntrusionOk = value['ifcmsgchanged:lockdowntoaccessctrlintrusion'] || null
      state.current.restoreToAccessCtrlIntrusionOk = value['ifcmsgchanged:restoretoaccessctrlintrusion'] || null
      state.current.restoreFromAccessCtrlIntrusionOk = value['ifcmsgchanged:restorefromaccessctrlintrusion'] || null
    } else {
      state.current = {
        id: '',
        acm: {},
        active: '',
        boschPanel: {},
        building: '',
        dhcp: '',
        gateway: '',
        info: {},
        informaCastFusion: {},
        ipAddress: '',
        lockdownLogs: [],
        lockdownFromAccessCtrlIntrusionOk: null,
        lockdownToAccessCtrlIntrusionOk: null,
        restoreToAccessCtrlIntrusionOk: null,
        restoreFromAccessCtrlIntrusionOk: null,
        messageTemplates: {},
        name: '',
        reenableTime: null,
        restoreLogs: [],
        server: '',
        subnetMask: '',
        system: ''
      }
      state.update = {
        id: '',
        active: false,
        reenableTime: null,
        building: ''
      }
    }
  },
  DAYLOCKDOWNHUB_UPDATE_ACTIVE (state, value) {
    state.update.active = value
  },
  DAYLOCKDOWNHUB_UPDATE_REENABLE_TIME (state, value) {
    state.update.reenableTime = value
  },
  DAYLOCKDOWNHUB_UPDATE_BUILDING (state, value) {
    state.update.building = value
  }
}
